export const DEFAULT_LABEL = 'Please share the details';
export const LABEL = 'You are enquiring about';
